(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@angular/core"), require("@angular/common"), require("@angular/forms"), require("rxjs/Subject"), require("@angular/platform-browser"), require("rxjs/BehaviorSubject"));
	else if(typeof define === 'function' && define.amd)
		define(["@angular/core", "@angular/common", "@angular/forms", "rxjs/Subject", "@angular/platform-browser", "rxjs/BehaviorSubject"], factory);
	else if(typeof exports === 'object')
		exports["angularMdlCore"] = factory(require("@angular/core"), require("@angular/common"), require("@angular/forms"), require("rxjs/Subject"), require("@angular/platform-browser"), require("rxjs/BehaviorSubject"));
	else
		root["angularMdlCore"] = factory(root["ng"]["core"], root["ng"]["common"], root["ng"]["forms"], root["rx"]["Subject"], root["ng"]["platformBrowser"], root["rx"]["BehaviorSubject"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_18__, __WEBPACK_EXTERNAL_MODULE_65__, __WEBPACK_EXTERNAL_MODULE_70__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition